import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { getOptions } from './settings'

i18n.use(initReactI18next).use(LanguageDetector).init(getOptions())
